import React from 'react';

import ModalConfirm from '../../shared/Modal/ModalConfirm';
import StatusHistory from './StatusHistory';
import store from './Store';

function ViewModal() {
  const { modalType } = store.modalParams;
  if (modalType === 'confirm') {
    return <ModalConfirm {...store} onCancel={store.toggleModal(false)} />;
  }
}

export default ViewModal;
